import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import { PlusSolidV6 } from "@shared/v2/Icomoon";
import Tasks from "../../../Tasks/components/People/Tasks";

const ViewAllTasksModal = (props) => {
  const {
    account,
    editTaskFromViewAll,
    isAgent,
    onClose,
    person,
    showReassignModal,
    showRescheduleModal,
    showDeleteModal,
    showTaskDetails,
    taskFromViewAll,
    user,
  } = props;

  return (
    <Modal
      id="view-all-tasks-modal"
      show
      onHide={onClose}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[1000px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header
        titleClassName="tw-flex tw-justify-between tw-items-center tw-w-full"
        title={
          <>
            <span>Tasks</span>
            <Button onClick={taskFromViewAll}>
              Create New Task <PlusSolidV6 size="s" />
            </Button>
          </>
        }
        closeButton
      />

      <Modal.Body id="content" className="tw-flex-1 tw-flex tw-flex-col tw-overflow-auto">
        <Tasks
          account={account}
          dueness="completed"
          user={user}
          taskable={person}
          agent={isAgent}
          editTask={editTaskFromViewAll}
          showReassignModal={showReassignModal}
          showRescheduleModal={showRescheduleModal}
          showDeleteModal={showDeleteModal}
          showTaskDetails={showTaskDetails}
        />
      </Modal.Body>

      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button schema="tertiary" size="medium" onClick={onClose}>
          Cancel
        </Button>
        <Button size="medium" onClick={onClose}>
          Done
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewAllTasksModal;
